import React, {useState, useEffect}  from 'react'
import { Container, Input, Text, Row, Spacer, Textarea, Button, Loading, Badge } from '@nextui-org/react'
import { auth, firestore } from '../config/firebase';
import { collection, doc, setDoc } from "firebase/firestore";
import { toast } from 'react-toastify';
import { useSms } from '../Hooks/useSms';
import useAuth from '../Hooks/useAuth';
import useApi from '../Hooks/useApi';

const SmsBlock = ({number}) => {
 
    var CryptoJS = require("crypto-js");
    const [smsText, setSmsText] = useState('')
    const [smsNumber, setSmsNumber] = useState('')
    const [smsStatus, setSmsStatus] = useState('')
    const [smsError, setSmsError] = useState('')
    const [smsLoading, setSmsLoading] = useState(false)
    const [timer, setTimer] = useState(0)
    const { user, loading } = useAuth();

    
    //Hook refresh historic sms
    const { sms, loadingSms, error, refreshSms } = useSms();

    //Hook get senders
    const { keys } = useApi();

    //Timer de 5 secondes après l'envoi du sms
    useEffect(() => {
        if (timer > 0) {
            setTimeout(() => setTimer(timer - 1), 1000);
        }
    }, [timer]);

    //Fonction qui transforme le numéro de téléphone en format international et enlève les espaces
    const formatNumber = (number) => {
        let formattedNumber = number.replace(/ /g, '')
        let numbers = formattedNumber.split(';')
        let formattedNumbers = []
        numbers.forEach(number => {
            if(number.startsWith('0')){
                formattedNumbers.push(number.replace('0', '+33'))
            } else if(number.startsWith('33')){
                formattedNumbers.push(number.replace('33', '+33'))
            }
        })
        formattedNumber = formattedNumbers.join(';')
        return formattedNumber
    }

    //Envoyer le sms via API OVH
    const sendSms = () => {
        const applicationKey = keys.applicationKey
        const applicationSecret = keys.applicationSecret
        const consumerKey = keys.consumerKey
        const serviceName = keys.serviceName
        const timestamp = Math.floor(Date.now() / 1000)
        const body = JSON.stringify({
            "charset": "UTF-8",
            "coding": "7bit",
            "message": smsText,
            "noStopClause": true,
            "priority": "high",
            "receivers": [formatNumber(smsNumber)],
            "senderForResponse": false,
            "sender": user.senderName,
            "class": "phoneDisplay",
        })
        const url = 'https://eu.api.ovh.com/1.0/sms/' + serviceName + '/jobs'
        const signature = '$1$' + CryptoJS.SHA1(applicationSecret + '+' + consumerKey + '+POST+' + url + "+" + body + '+' + timestamp)

        setSmsLoading(true)
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Ovh-Application': applicationKey,
                'X-Ovh-Consumer' : consumerKey,
                'X-Ovh-Signature' : signature,
                'X-Ovh-Timestamp' : timestamp,
            },
            body: body
        })
        .then(response => response.json())
        .then(data => {
            setSmsStatus(data.status)
            setSmsLoading(false)
            setTimer(5)
            if (data.invalidReceivers.length > 0) {
                //Ajouter le sms non envoyé dans la collection sms de firebase
                const subCollectionRef = collection(firestore, "users", auth.currentUser.uid, "sms")
                const docRef = doc(subCollectionRef);
                setDoc(docRef, {
                    number: data.validReceivers,
                    text: smsText,
                    status: "Error",
                    date: new Date()
                });
                toast.error("Le numéro de téléphone est invalide - Message non distribué.", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    theme: "colored",
                })
                refreshSms()
            } else if (data.validReceivers.length > 0) {
                try {
                    //Ajouter le sms envoyé dans la collection sms de firebase
                    const subCollectionRef = collection(firestore, "users", auth.currentUser.uid, "sms")
                    const docRef = doc(subCollectionRef);
                    setDoc(docRef, {
                        number: data.validReceivers,
                        text: smsText,
                        status: "Success",
                        date: new Date(),
                    });
                    toast.success("Le sms a bien été envoyé.", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: false,
                        theme: "colored",
                    })
                    refreshSms()
                } catch (e) {
                    console.log(e)            
                    toast.error("Une erreur lors de l'enregistrement.", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: false,
                        theme: "colored",
                    })
                }
            }
        })
        .catch((error) => {
            setSmsError(error)
            setSmsLoading(false)
        });
    }

    //Lors d'un changement de texte, on met à jour le state
    const handleTextChange = (e) => {
        setSmsText(e.target.value)
    }


    useEffect(() => {
        if (number) {
            setSmsNumber(number)
        } else if (smsNumber) {
            setSmsNumber(smsNumber)
        }
    }, [number])
    
    return (
        <Container responsive xs css={{ shadow: "$lg", borderRadius: '$2xl', pb: '$5' }}>
            <Row>
                <Text h3 css={{textGradient: "45deg, $blue600 -20%, $pink600 50%", mt:'$3' }}>Envoyez un sms</Text>
                <Spacer x={1}/>
            </Row>
            {
                user?.senderName === '' ? (
                    <Row justify='center'>
                        <Badge color={'error'} variant="default" css={{ mt: '$3', ml: '$3' }}>Aucun nom d'expediteur n'a été définie, veuillez en définir un.</Badge>
                    </Row>
                ) : (
                    <Row justify='center'>
                        <Badge color={'warning'} variant="default" css={{ mt: '$3', ml: '$3' }}>Nom d'expéditeur : {user?.senderName}</Badge>
                    </Row>
                )
            }
            <Spacer y={1}/>
            <Input
                css={{ width: '100%' }}
                clearable
                bordered
                label="Numéro de téléphone"
                placeholder="06 00 02 00 18"
                color="primary"
                size="lg"
                type={'tel'}
                onChange={(e) => setSmsNumber(e.target.value)}
                value={smsNumber}
                helperColor="primary"
                helperText='Séparez les numéros par un point-virgule " ; "'
                contentRight={loading ? <Loading type="spinner" color="currentColor" /> : null}
            />  
            <Spacer y={1}/>
            <Textarea
                css={{ width: '100%', }}
                bordered
                rows={7}
                label="Message"
                color='primary'
                size="lg"
                placeholder="Ecrire votre message..."
                onChange={(e) => handleTextChange(e)}
            />
            <Spacer y={2}/>
            <Row justify='center'>
            {
              loading ? (
                <Button auto bordered color={'primary'} css={{ px: "$13" }}>
                  <Loading type="points" color="currentColor" size="sm" />
                </Button>
              ) : (
                user?.senderName === '' || smsNumber === '' ? (
                <Button
                    size='lg'
                    color={'primary'}
                    shadow
                    disabled
                >
                    Envoyer
                </Button>
                ) : (
                    <Button
                    size='lg'
                    color={'primary'}
                    shadow
                    onClick={() => sendSms()}
                    >
                        Envoyer
                    </Button>
                    )
                )
            }
            </Row>
            <Row align='center'>
                {
                    smsStatus ?
                        smsStatus === 'success' ?
                    <Container css={{mt: '$3'}}>
                        <Badge enableShadow disableOutline color="success">
                            Message envoyé avec succès.
                        </Badge>     
                    </Container>
                            :
                    <Container css={{mt: '$3'}}>
                        <Badge enableShadow disableOutline color="error">
                            {smsError}
                        </Badge>        
                     </Container>
                    :
                    <></>       
                }
            </Row>
        </Container>
    )
}

export default SmsBlock